import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { CustomValidationService } from '../../services/custom-validation.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { UserService } from 'src/app/core/Services/user.service';
import { FormControl, FormGroup } from '@angular/forms';
import { CustomValidation } from 'src/app/shared/validators/customValidators';

@Component({
  selector: 'app-custom-validation',
  templateUrl: './custom-validation.component.html',
  styleUrls: ['./custom-validation.component.css']
})
export class CustomValidationComponent implements OnInit {
  @ViewChildren('focusedElement') focusedElement!: QueryList<any>;
  totalCount!: number;
  page_no: number = 1;
  page_limit: number = 10;
  public showNavigation: boolean = false;
  customValidationList: any[] = [];
  sortParams: any;
  columnSort: any = {
    requestValidationId: {
      sortType: 'ascending',
    },
    validation: {
      sortType: 'ascending',
    },
    executionOrder:{
      sortType:'ascendeing'
    }
  };
  customVaidationFilterForm!:FormGroup
  constructor(
    private customValidationService: CustomValidationService,
    private toasterandLoader: ToasterService,
    private userService: UserService
  ) { 
    this.customVaidationFilterForm = new FormGroup({
      requestValidationId: new FormControl(null),
      validation: new FormControl(null),
  }, CustomValidation.formNotNull);
  }

  ngOnInit():void {

  }

  isScrollIntoViewNeeded() :void{
    setTimeout(() => {
      this.focusedElement.last?.nativeElement.scrollIntoView();
    }, 100);
  }

  currentPageDetail(event: any):void {
    if (event) {
      this.page_no = event.button_no;
      this.page_limit = event.item_per_page;
    }
    this.isScrollIntoViewNeeded();
    this.getCustomValidationList();
  }

  setStatusValue(status: number): string {
    return status ? 'Enabled' : 'Disabled'
  }
  getCustomValidationList():void {
    this.toasterandLoader.isLoaderEnable(true);
    let payload = {
      per_page: this.page_limit,
      page: this.page_no,
      sort:this.sortParams,
      validation:this.customVaidationFilterForm?.value?.validation || '',
    }
    this.customValidationService.getCustomValidationList(payload).subscribe({
      next: (list) => {
        if(list.data){
          this.customValidationList = list.data?.data;
          if (!this.customValidationList.length) this.showNavigation = true;
          this.totalCount = list?.data?.total;
        }
        this.toasterandLoader.isLoaderEnable(false);
        
      }, error: (error) => {
        this.toasterandLoader.isLoaderEnable(false);
        this.toasterandLoader.alert.toast({
          title: 'Error',
          type: 'error',
          message: 'Something went Wrong',
        });
      }
    });
  }
  setValidationStatus(id: number):void {
    this.toasterandLoader.isLoaderEnable(true);
      this.customValidationService.setValidationStatus(id).subscribe({
      next: (response) => {
        if (response) {
          this.toasterandLoader.isLoaderEnable(false);
          this.toasterandLoader.alert.toast({
            title: 'Success',
            type: 'success',
            message: response?.message,
          });
        }
      },
      error: (error) => {
        this.toasterandLoader.isLoaderEnable(false);
        this.toasterandLoader.alert.toast({
          title: 'Error',
          type: 'error',
          message: error?.message,
        });
      },
    });
   
  }
  checkPermission(perName: string): boolean {
    return this.userService.getPermissions(perName);
  }

  sortColumn(colName: string):void {
    for (const key in this.columnSort) {
        if (Object.prototype.hasOwnProperty.call(this.columnSort, key)) {
            const element = this.columnSort[key];
            if (key == colName) {
                this.columnSort[colName].clicked = true;
                this.columnSort[colName].sortType = (this.columnSort[colName].sortType == 'ascending') ? 'descending' : 'ascending';
                this.sortParams = (this.columnSort[colName].sortType == 'descending' ? '-' : '') + colName;
                this.getCustomValidationList();   
            }else{
                this.columnSort[key].sortType = 'ascending';
            }
        }   
    }
  }
  resetFilter():void{
    this.customVaidationFilterForm.reset();
    this.page_limit = 10;
    this.page_no = 1;
    this.totalCount=1;
    this.showNavigation = false;
    this.getCustomValidationList();   


  }

  confirmUpdate(i:number):boolean{
    this.toasterandLoader.alert.confirm({
      text: `Request validation status will be updated. Do you wish to proceed?`,
      type: 'warning',
      hideCancelButton: false,
      okText: 'Yes',
      cancelText: 'No',
      title: 'Are you sure?',
    }).then((res)=>{
    if(res){
      this.customValidationList[i].isActive=! this.customValidationList[i].isActive;
      this.setValidationStatus(this.customValidationList[i].requestValidationId)
    }
    });
    return false;  
  }


}
